import { deepMerge } from '../core/utils.js'
import assetsmanagerZhTW from './assetsmanager/zh-TW.json'
import assetsmanagerEnUS from './assetsmanager/en-us.json'
import commonZhTW from './common/zh-TW.json'
import commonEnUS from './common/en-us.json'
import layoutZhTW from './layout/zh-TW.json'
import layoutEnUS from './layout/en-us.json'
import monitorZhTW from './monitor/zh-TW.json'
import monitorEnUS from './monitor/en-us.json'

export const modules = {
  common: {
    'zh-TW': commonZhTW,
    'en-us': commonEnUS,
  },
  layout: {
    'zh-TW': layoutZhTW,
    'en-us': layoutEnUS,
  },
  assetsmanager: {
    'zh-TW': assetsmanagerZhTW,
    'en-us': assetsmanagerEnUS,
  },
  monitor: {
    'zh-TW': monitorZhTW,
    'en-us': monitorEnUS,
  },
}

const mergeModules = (lang) => {
  let messages = {}
  for (const [module, packs] of Object.entries(modules)) {
    const source = packs[lang] ?? {}
    messages = deepMerge(messages, source, { scope: module })
  }
  return messages
}

export const messages = {
  'zh-TW': mergeModules('zh-TW'),
  'en-us': mergeModules('en-us'),
}
